<template>
    <div v-if="selectedBot && selectedBot.packages">
        <template>
            <div style="padding: 0px 15px;">
                <div style="margin: 35px 0px;">
                    <h3 class="text-center title">
                        Facebook Chatbot Package
                    </h3>
                </div>
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                        <div class="card-package">
                            <h3 class="title">3 Months</h3>
                            <br>
                            <p>Price 1,500 Baht</p>
                            <p>500 Baht per month</p>

                            <hr>
                            <p>Premium Features: <br>Advanced Broadcast, Training,<br> Advanced CRM</p>
                            <hr>
                            <div ref="btn_3month_fb" id="btn_3month_fb"></div>

                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                        <div class="card-package">
                            <div class="sale-tag shadow">
                                SAVE 7%
                            </div>
                            <h3 class="title">6 Months</h3>
                            <br>
                            <p>Price 2,799 Baht</p>
                            <p>466.5 Baht per month</p>

                            <hr>
                            <p>Premium Features: <br>Advanced Broadcast, Training,<br> Advanced CRM</p>
                            <hr>
                            <!-- <p style="color:red">Save 1,000 baht</p> -->
                            <div ref="btn_6month_fb" id="btn_6month_fb"></div>

                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                        <div class="card-package">
                            <div class="sale-tag shadow">
                                SAVE 17%
                            </div>
                            <h3 class="title">1 Year</h3>
                            <br>
                            <p>Price 4,999 Baht</p>
                            <p>416.58 Baht per month</p>

                            <hr>
                            <p>Premium Features: <br>Advanced Broadcast, Training,<br> Advanced CRM</p>
                            <hr>
                            <!-- <p style="color:red">Save 1,000 baht</p> -->
                            <div ref="btn_12month_fb" id="btn_12month_fb"></div>

                        </div>
                    </div>
                </div>
            </div>

            <template v-if="false">
                <div>
                    <div style="margin: 35px 0px;">
                        <h3 class="text-center title">
                            Add-on Line Chatbot Package
                        </h3>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                            <div class="card-package">
                                <strong>Basic Package</strong>
                                <hr>
                                <h3 class="title">+1,498 Baht / Month</h3>
                                
                                <hr>
                                <p>1 Basic Line@ Account</p>
                                <hr>
                                <p>1 Line Chatbot</p>
                                <hr>

                                <a :href="'mailto:'+ $store.state.theme.email_contact" class="btn btn-select-plan">Contact Us</a>

                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                            <div class="card-package">
                                <strong>Pro Package</strong>
                                <hr>
                                <h3 class="title">+2,498 Baht / Month</h3>
                                
                                <hr>
                                <p>1 Pro Line@ Account</p>
                                <hr>
                                <p>1 Line Chatbot</p>
                                <hr>
                                
                                <!-- <p style="color:red">Save 1,000 baht</p> -->
                                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan">Contact Us</a>

                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 text-center">
                            <div class="card-package">
                                <strong>Pro+ Package</strong>
                                <hr>
                                <h3 class="title">+7,388 Baht / Month</h3>
                                
                                <hr>
                                <p>1 Pro+ Line@ Account</p>
                                <hr>
                                <p>1 Line Chatbot</p>
                                <hr>
                                
                                <!-- <p style="color:red">Save 1,000 baht</p> -->
                                <a :href="'mailto:' + $store.state.theme.email_contact" class="btn btn-select-plan">Contact Us</a>

                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <modal-dialog @close="showSuccess = false" v-if="showSuccess">
                <span slot="header">Payment Successful</span>

                <div slot="body" class="text-center">
                    <img src="/static/img/assets/shop/success_mark.png" alt="" style="width: 150px;">
                    <h3>Payment Successful</h3>
                </div>

                <div slot="footer">
                    <a href="javascript:void(0)" class="btn btn-primary" @click="showSuccess = false">Close</a>
                </div>
            </modal-dialog>

            <modal-dialog @close="showFail = false" v-if="showFail">
                <span slot="header">Payment Unsuccessful</span>

                <div slot="body" class="text-center">
                    <img src="/static/img/assets/shop/fail_mark.png" alt="" style="width: 150px;">
                    <h3>Payment Unsuccessful</h3>
                    <p class="small">{{errorMessage}}</p>
                </div>

                <div slot="footer">
                    <a href="javascript:void(0)" class="btn btn-primary" @click="showFail = false">Close</a>
                </div>
            </modal-dialog>
            
        </template>
        <template v-if="false">
        <div v-if="!selectedBot.packages.includes('line')">
            
        </div>
        <div v-else>
            <div  class="text-center" style="margin-top: 35px;">
                <div><img src="/static/img/assets/setting/expired_alert@2x.png" alt="" style="max-width: 230px; width: 100% "></div>
                <br>
                <p>Please contact email <a :href="'mailto:' + $store.state.theme.email_contact">{{$store.state.theme.email_contact}}</a> for more information. </p>
            </div>
        </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ModalDialog from '@/components/elements/ModalDialog'
import { setInterval, clearInterval } from 'timers';

    export default {
        data: function(){
            return {

                environment: 'production',
                showSuccess: false,
                showFail: false,
                errorMessage: ''
            }
        },
        components: {
            ModalDialog
        },
        computed:{
            ...mapGetters({
                selectedBot: 'selectedBot',
                botlist: 'botlist'
            }),
        },
        mounted: function(){
            var vm = this

            vm.$nextTick(function(){
                vm.renderPaypalBtn('#btn_3month_fb','3month_fb')
                vm.renderPaypalBtn('#btn_6month_fb','6month_fb')
                vm.renderPaypalBtn('#btn_12month_fb','12month_fb')
            })
        },
        methods: {
            renderPaypalBtn: function(btn_name,itemname){
                var SERVER = "https://zwizai.herokuapp.com"
                var vm = this
                // console.log(btn_name,$(btn_name),vm.$refs[btn_name])
                // console.log(vm.$refs[btn_name])
                if ($(btn_name).get(0)) {
                    paypal.Button.render({
                        locale: 'th_TH',
                        env: vm.environment, // Or 'production'
                        // Set up the payment:
                        // 1. Add a payment callback
                        payment: function(data, actions) {
                        // 2. Make a request to your server
                            return actions.request.post(SERVER+'/my-api/create-payment/', {
                                itemname: itemname,
                                pageid: vm.selectedBot.pageid
                            })
                            .then(function(res) {
                            // 3. Return res.id from the response
                                return res.id;
                            });
                        },
                        // Execute the payment:
                        // 1. Add an onAuthorize callback
                        onAuthorize: function(data, actions) {
                        // 2. Make a request to your server
                            return actions.request.post(SERVER+'/my-api/execute-payment/', {
                                paymentID: data.paymentID,
                                payerID:   data.payerID,
                                itemname: itemname,
                                pageid: vm.selectedBot.pageid
                            })
                            .then(function(res) {
                            // 3. Show the buyer a confirmation message.
                                // alert("payment completed");
    
                                // console.log(res)
                                vm.$store.dispatch('loading')
                                if (res.status == 'success') {
                                    vm.$store.dispatch('updateBotDetail').then(
                                    function(){
                                        vm.$store.dispatch('loading')
                                        vm.showSuccess = true
                                    }, function(error){
                                        vm.$store.dispatch('loading')
                                        vm.errorMessage = 'Can not update chatbot'
                                        vm.showFail = true
                                    })
                                    
                                } else {
                                    vm.errorMessage = res.status
                                    vm.showFail = true
                                }
                            });
                        }
                    }, btn_name);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/setting/ViewPackage.vue